import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class BOLFilter {
  scac:any = "";
  bolId:any = "";
  routeId:any = "";
  driverId:any = "";
  selectedDate: NgbDate;
  selectedDateText: string;
  logon:any = "";
  fname:any = "";
  lname:any = "";
}
